/**
 * Simplified field value for readonly display
 * Used when showing field values without full form structure
 */
export class DisplayFieldValueEntity {
  public label!: string;
  public value!: string;
}
